import axios from "../../utils/axios";

export const getPaginatedVideos = async (tags, search, author, index=1) => {
    let queryString = "";

    if (tags?.length > 0) {
        queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
    }

    if (search !== "") {
        queryString += `&q=${search}`;
    }
    if (author !== "") {
        queryString += `&author_like=${author}`;
    }
    const response = await axios.get(`/videos/?${queryString}&_page=${index}&_limit=4`);

    return response.data;
};
